import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url'
import { pdfjs } from 'react-pdf'

// Worker は同梱して SW の precache に載せる（CDN 取得を待たずに起動でき、オフラインでも動く）
pdfjs.GlobalWorkerOptions.workerSrc = workerSrc

// CJK文字用CMap設定 + JPEG2000 デコード用 OpenJPEG WASM (pdf.js v5+ 必須)
// wasmUrl 未指定だと `JpxError: OpenJPEG failed to initialize` で JPX 画像を
// 含む PDF (画像スキャン系など) が白画面のまま描画されない
export const PDF_RESOURCE_OPTIONS = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  cMapPacked: true,
  wasmUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/wasm/`,
}
